import { ERROR_LOGIN } from '../Error';

export const checkAuth = (showAlert) => {
  const logged = sessionStorage.logged;
  if (!logged) {
    if (showAlert) alert(ERROR_LOGIN);
    return false;
  }
  return true;
};
